<template>
<div class="header">
  <div class="header-main">
    <img src="../assets/logo.png" alt="" @click="goHome">
  </div>
</div>
</template>

<script>
export default {
  name: 'Header',
	methods:{
		goHome(){
			window.location.href = 'https://www.jundakuaidi.com/'
		}
	}
}
</script>

<style scoped>
  .header {
    height: 115px;
    background: #f5f5f5;
    border-bottom: 1px solid #DFDFDF;
  }
  .header-main {
    box-sizing: border-box;
    padding-left: 216px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
  }
  .header-main img {
    width: 100px;
    height: 90px;
    cursor: pointer;
  }
</style>
